import React, { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import "../Activities/Styles/ActivityForm.css";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// import Input from "@mui/material/Input";
import OutlinedInput from "@mui/material/OutlinedInput";
import axios from "axios";
import ApiSettings from "../../.././../../Settings/ApiSettings.json";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useGlobalContext } from "../../../../../context";

// import Cookies from "universal-cookie";
// const cookies = new Cookies();

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function UpdateIncomeEstimateClass(props) {
    const [incomeEstimateClass, setIncomeEstimateClass] = useState({
    needsCommittee: props?.object?.needs_committee?props.object.needs_committee:0,
    committeeStatusId: props?.object?.committee_status_id?props.object.committee_status_id:0,
    committeeResult: props?.object?.committee_result?props.object.committee_result:0,
    varietiesWithCarrierId: props?.object?.varieties_with_career?.id? props.object.varieties_with_career.id:null,
    varietiesWithCarrier: props?.object?.varieties_with_career? props.object.varieties_with_career:null,
    notes: props?.object?.notes? props.object.notes:null,
    });
    const [classAmount, setClassAmount] = useState(0);
    const [messageErrors, setMessageErrors] = useState([]);
     
  const [loading, setLoading] = useState(false);
  const [IpAddress, setIpAddree] = useState("");
  const [dataOFVarieties, setdataOFVarieties] = useState([]);
  const [dataOfGroupsCarriers, setdataOfGroupsCarriers] = useState([]);
  const [careerName, setCareerName] = useState("");
  const [selectedGroupCarrier, setselectedGroupCarrier] = useState({});

  const [selectedVarietiesCarrierName, setselectedVarietiesCarrierName] =
    useState([]);

  const [selectedCalculationType, setselectedCalculationType] = useState(0);
  const [amountForEachVarietiesCarriers, setamountForEachVarietiesCarriers] =
    useState([]);
  const [relatedGroupCarriersDate, setrelatedGroupCarriersDate] = useState([]);
  const [showBoxOfAddCarriers, setshowBoxOfAddCarriers] = useState(false);

  const [filteredDataForCarrier, setfilteredDataForCarrier] = useState([]);
  const [ErrorMessage, setErrorMessage] = useState({
    activityTypeError: "",
    CalculationTypeError: "",
    VaritiesCarrierError: "",
  });

  const [selectedIdForVarieties,setSelectedIdForVarieties]=useState(null)

  const {
    // loading,
    committeeStatusesList,
    activitiesByIncomeTaxReportId,
    fetchData,
  } = useGlobalContext();
  
  const [object, setObject] = useState(props.object);

  useEffect(() => {
    // if (!cookies.get("role_id")) {
    //   window.location.href = "/";
    // }
    fetchData(
        "ACTIVITIES_BY_INCOME_TAX_REPORT_ID",
        "activities_by_income_tax_report_id",
        { 
            income_tax_report_id: props?.object?.income_tax_report?.id
        }
      );
  }, []);

  useEffect(() => {
    setObject(props?.object);
    console.log(activitiesByIncomeTaxReportId);
    setClassAmount(props?.object?.varieties_with_career?.amount)
    setIncomeEstimateClass({
        ...incomeEstimateClass,
        varietiesWithCarrierId: props?.object?.varieties_with_career?.id? props.object.varieties_with_career.id:null,
        varietiesWithCarrier: props?.object?.varieties_with_career? props.object.varieties_with_career:null,
    })
  }, [props.object]);

  //const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  //get data of varieties Carrier ....
  const getDataOfVarietiesCarrier = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/VarietiesCarrier/show",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setdataOFVarieties(data.data.data);
          setCareerName(props?.object?.carrier?.name);
          setselectedGroupCarrier(props?.object?.carrier?.groups_carriers);
          setselectedCalculationType(
            props?.object?.calculate_type?.type == "formula" ? 1 : 0
          );
          pushSelectedVarietiesCarrierName(
            props?.object?.varieties_carrier?.name
          );
          pushAmountForVarietiesCarrier(
            props?.object?.amount,
            props?.object?.varieties_carrier?.name
          );
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };

  //get data of group Carrier ....
  const getDataOfGroupsCarriers = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/GroupsCarrier/show",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setdataOfGroupsCarriers(data.data.data);
        }
      }
    } catch (err) {
      // alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };

  // get related carriers for each group you selected.
  const getrelatedGroupCarriersDate = async (item) => {
    let data = null;
    try {
      data = await axios({
        method: "post",
        url: IpAddress + "/GroupsCarrier/getRelatedCarriers",
        data: {
          GroupsCarriersID: item.id,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setfilteredDataForCarrier([]);
          setrelatedGroupCarriersDate(data.data.data);
          let dataTemp = data.data.data;
          let arrTemp = [];
          dataTemp.forEach((element) => {
            setfilteredDataForCarrier((item) => [
              ...item,
              {
                id: element.id,
                name: element.name,
                Categories: "أ",
              },
            ]);
          });
        } else {
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
    }
  };

  //sent data of new carriers with the related informatio with Varieties carrier..
  const sentDataOFNewCarrier = async () => {

    setLoading(true);
    let data = null;
    let formData = {
      id:props?.object?.id,
      commit_result:incomeEstimateClass.committeeResult,
      committee_need:incomeEstimateClass.needsCommittee,
      committee_status_id:incomeEstimateClass.committeeStatusId,
      varieties_with_career_id:incomeEstimateClass.varietiesWithCarrierId,
      notes:incomeEstimateClass.notes
    };

    try {
      data = await axios({
        method: "put",
        url: IpAddress + "/income_estimate_class/update",
        data: formData,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          props.advanceSearch()
          props.setshowBoxOfEditForm(false)
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
        } else {
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  const { vertical, horizontal, open } = snackBar;
  useEffect(() => {
    setIpAddree(ApiSettings.apiUrl);
    getDataOfVarietiesCarrier(ApiSettings.apiUrl);
    getDataOfGroupsCarriers(ApiSettings.apiUrl);
  }, []);

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  //push selected varietiesCarrierName
  const pushSelectedVarietiesCarrierName = (name) => {
    console.log("name", name);
    console.log("selectedVarietiesCarrierName", selectedVarietiesCarrierName);
    if (selectedVarietiesCarrierName.length > 0) {
      let checkifExists = selectedVarietiesCarrierName.includes(name);
      if (!checkifExists) {
        setselectedVarietiesCarrierName((item) => [...item, name]);
        setamountForEachVarietiesCarriers((item) => [
          ...item,
          {
            amount: "",
            flag: name,
          },
        ]);
        return;
      }
      setselectedVarietiesCarrierName(
        selectedVarietiesCarrierName.filter((item) => item !== name)
      );
      setamountForEachVarietiesCarriers(
        amountForEachVarietiesCarriers.filter((item) => item.flag !== name)
      );
      return;
    } else {
      setselectedVarietiesCarrierName((item) => [...item, name]);
      setamountForEachVarietiesCarriers((item) => [
        ...item,
        {
          amount: "",
          flag: name,
        },
      ]);
    }
  };

  const pushAmountForVarietiesCarrier = (amount, flag) => {
    let getArray = [...amountForEachVarietiesCarriers];
    for (let i = 0; i < getArray.length; i++) {
      if (getArray[i].flag == flag) {
        getArray[i].amount = amount;
      }
    }
    console.log("amount, flag", amount, flag);
    console.log("getarray", getArray);
    setamountForEachVarietiesCarriers(getArray);
    // console.log(getArray);
  };

  const setselectedID=(id)=>{
    Array.isArray(activitiesByIncomeTaxReportId) &&
    activitiesByIncomeTaxReportId?.map((activity) => {
      if(incomeEstimateClass.varietiesWithCarrierId){
        
      }
    })
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexFlow: "row wrap",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            backgroundColor: "#5f7b8a",
            color: "#FFFFFF",
            paddingTop: 10,
            paddingBottom: 10,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h2>تعديل بيانات النشاط و اللجنة</h2>
        </div>
        <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexFlow: "row wrap",
          width: "98%",
          minWidth: 200,
          border: "1px solid",
          borderColor: "#5f7b8a",
          borderRadius: 10,
          margin: 10,
          paddingBottom: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            minWidth: 200,
            marginTop: 10,
            paddingLeft: 10,
            paddingTop: 10,
            paddingRight: 10,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FormControl fullWidth className="d-flex flex-row">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    value={
                      incomeEstimateClass.needsCommittee == 1 ? true : false
                    }
                    checked={incomeEstimateClass.needsCommittee == 1 ? true : false}
                    onChange={(e) => {
                      setIncomeEstimateClass({
                        ...incomeEstimateClass,
                        needsCommittee: e.target.checked==true? 1 : 0,
                      });
                    }}
                  />
                }
                label="هل تريد تعيين لجنة للتخمين؟"
              />
            </FormGroup>
          </FormControl>

          <Typography className="fontForError"></Typography>
        </div>

        <div
          style={{
            display: incomeEstimateClass.needsCommittee ? "flex" : "none",
            flexDirection: "row",
            flexFlow: "row wrap",
            width: "100%",
            minWidth: 200,
            // border: "1px solid",
            borderColor: "#5f7b8a",
            borderRadius: 10,
            margin: 10,
            paddingBottom: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              // width: "20%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="career-simple-select-label">
                حالة نتيجة اللجنة
              </InputLabel>
              <Select
                labelId="career-simple-select-label"
                id="career-simple-select"
                value={incomeEstimateClass.committeeStatusId}
                label="حالة نتيجة اللجنة"
                onChange={(e) => {
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    committeeStatusId: e.target.value,
                  });
                }}
              >
                {committeeStatusesList?.map((committeeStatus) => {
                  return (
                    <MenuItem
                      value={committeeStatus.id}
                      key={committeeStatus.id + "_type"}
                    >
                      {committeeStatus.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>
           {
            incomeEstimateClass.committeeStatusId==5?
          <div
            style={{
              display: "flex",
              // width: "33%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingTop: 10,
              paddingLeft: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <TextField
                label="القيمة المحددة من قبل اللجنة"
                variant="outlined"
                value={incomeEstimateClass.committeeResult}
                onChange={(e) => {
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    committeeResult: e.target.value,
                  });
                }}
              />
            </FormControl>
            <Typography className="fontForError"></Typography>
          </div>:null
}

        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexFlow: "row wrap",
            width: "100%",
            minWidth: 200,
            // border: "1px solid",
            borderColor: "#5f7b8a",
            borderRadius: 10,
            margin: 10,
            paddingBottom: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              // width: "20%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="career-simple-select-label">
                اختر صنف النشاط
              </InputLabel>
              <Select
                labelId="career-simple-select-label"
                id="career-simple-select"
                value={incomeEstimateClass.varietiesWithCarrierId}
                label="اختر صنف النشاط"
                onChange={(e) => {
                  setClassAmount(e?.target?.value?.amount);
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    varietiesWithCarrierId: e?.target?.value,
                    // varietiesWithCarrier: e?.target?.value,
                  });
                //   setselectedID(e.target.value)
                }}
              >
                {Array.isArray(activitiesByIncomeTaxReportId) &&
                  activitiesByIncomeTaxReportId?.map((activity) => {
                    return (
                      <MenuItem value={activity.id} key={activity?.id + "_type"}>
                        {activity?.varieties_carrier?.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>
          <div
            style={{
              display: "flex",
              // width: "33%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingTop: 10,
              paddingLeft: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              <TextField
                label="القيمة المحددة للصنف المختار"
                variant="outlined"
                value={classAmount}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(e) => {}}
              />
            </FormControl>
            <Typography className="fontForError"></Typography>
          </div>
        </div>
        </div>

          <div
            style={{
              display: "flex",
              // width: "20%",
              flex: 1,
              minWidth: 200,
              marginTop: 10,
              paddingLeft: 10,
              paddingTop: 10,
              paddingRight: 10,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth>
              {/* <InputLabel id="career-simple-select-label2">
               ملاحظات
              </InputLabel> */}
              <TextField
                labelId="career-simple-select-label2"
                id="career-simple-select"
                value={incomeEstimateClass.notes}
                multiline
                minRows={4}
                label="ملاحظات"
                onChange={(e) => {
                  setIncomeEstimateClass({
                    ...incomeEstimateClass,
                    notes: e.target.value,
                  });
                }}
              />
            </FormControl>

            <Typography className="fontForError"></Typography>
          </div>
      </div>

      <div
        style={{
          display: "flex",
          marginTop: 10,
          backgroundColor: "#fefefe",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 30,

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: "#5f7b8a",
            width: "50%",
          }}
          onClick={() => sentDataOFNewCarrier()}
        >
          {!loading ? (
            "تحديث"
          ) : (
            <div class="spinner-border " role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          )}
        </Button>
      </div>

      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
